import { createSlice } from '@reduxjs/toolkit'

import { IWalletReducers, IWalletState } from './wallet.types'

const initialState: IWalletState = {
  loading: false,
  error: '',
  balance: '0',
}

const { actions, reducer } = createSlice<IWalletState, IWalletReducers, 'wallet'>({
  name: 'wallet',
  initialState,
  reducers: {
    getWalletLoyaltyBalanceRequest: (state) => {
      state.loading = true
      state.error = ''
    },
    getWalletLoyaltyBalanceSuccess: (state, action) => {
      state.loading = false
      state.balance = action.payload.balance
    },
    getWalletLoyaltyBalanceFailure: (state, action) => {
      state.loading = false
      state.error = action.payload.error
    },
    getWalletBalanceRequest: (state) => {
      state.loading = true
      state.error = ''
    },
    getWalletBalanceSuccess: (state, action) => {
      state.loading = false
      state.balance = action.payload.balance
    },
    getWalletBalanceFailure: (state, action) => {
      state.loading = false
      state.error = action.payload.error
    },
  },
})

export { actions as WalletActions }

export { reducer as walletReducer }
